<template>
  <div>
    <div class="main-add-services">
      <button class="btn btn-block emergo-green-button" v-on:click="goToMarketPlace">
        <img class="add_icon_img" src="/static/images/icons/plus_icon.svg" alt="plus-icon" />
        Add
        <span class="hidden-xs">More Services</span>
      </button>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 box-wrapper">
      <div>
        <div class="acct-service">Account</div>
        <hr class="upper-line" />
        <div class="row">
          <div class="col-lg-7 col-md-8 col-sm-7 col-xs-6 team-members">
            <div class="col-xs-12 pl-0" :class="{ 'col-md-5 col-lg-5': restrictedUsersCount > 0 }">
              <div class="team-member-reg">Team Members</div>
              <div class="records-available" v-if="Object.keys(teamMember).length">
                <span class="available-item">
                  <span v-if="isREP"
                    >{{
                      teamMember.current_utilization - 1 >= teamLimit
                        ? 0
                        : teamLimit - (teamMember.current_utilization - 1)
                    }}
                    of {{ teamLimit }}</span
                  >
                  <span v-else
                    >{{
                      teamMember.current_utilization >= teamLimit
                        ? 0
                        : teamLimit - teamMember.current_utilization
                    }}
                    of {{ teamLimit }}</span
                  >
                </span>
                <span class="available-upto">&nbsp;available</span>
              </div>
            </div>
            <div
              class="col-md-7 col-lg-7 col-xs-12 pl-0 display-flex hidden-xs font-16"
              v-if="restrictedUsersCount > 0"
            >
              <div class="alert-image">
                <span class="tooltiptext"
                  >Your Team Member upgrade has expired. Every RAMS account can have up to 5 free
                  users. Navigate to your team list to unblock up to 4 additional team members. For
                  5+ member access, upgrade your account at any time from the Services page under
                  Account Settings.</span
                >
              </div>
              <span
                >Your Account has <br />
                restricted team members</span
              >
            </div>
            <div
              class="col-xs-12 pl-0 free-renews"
              v-if="teamMember.total_limit > teamMember.default_limit"
            >
              <span class="expiration-title" v-if="teamMember.expiry_date">
                <img
                  class="traingle-alert"
                  src="/static/images/icons/alert_triangle.svg"
                  alt="alert-icon"
                />
                <b>Expires</b> {{ teamMember.expiry_date | dateFormat }}
              </span>
              <span v-else>
                <span>Expires on </span>
                {{ teamMember.valid_until | dateFormat }}
              </span>
            </div>
          </div>
          <div
            class="col-lg-5 col-md-4 col-sm-5 col-xs-6 pl-0 small-update-service position-relative"
          >
            <div class="upgrade-service" v-if="teamPrice">${{ teamPrice }} per year</div>
            <div class="upgrade-service" v-if="!teamMember.expiry_date && !teamMember.renewed">
              <button
                class="btn emergo-white-button"
                data-toggle="modal"
                data-target="#UpgradeModal"
                @click="upgradeService('', 'account')"
              >
                Upgrade Account
              </button>
            </div>
            <div
              class="upgrade-service upgrade-service-btn"
              v-if="teamMember.expiry_date && !teamMember.renewed"
            >
              <button class="btn emergo-green-button" data-toggle="modal" data-target="#renewModal">
                Renew Members
              </button>
            </div>
            <div class="renew-class top_28" v-if="teamMember.renewed">
              <img
                src="static/images/icons/checkbox.svg"
                class="success_logo card-img-top"
                alt="checkbox-tick-icon"
              />
              <br />
              <span class="pt-10"> Renewed </span>
            </div>
          </div>
        </div>
      </div>
      <!-- <hr class="upper-line-services" /> -->
      <div class="row m-0">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-4 acct-service pt-15">Services</div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7 p-0 align-right">
          <button
            v-if="displayRenewAll && !isREP"
            class="btn emergo-blue-button renew-service"
            @click="renewExpiringServices()"
          >
            Renew all services expiring
          </button>
        </div>
      </div>
      <div
        class="row m-0"
        v-if="
          planList &&
          planList.length > 0 &&
          (!(!isREP && isProductClassificationActive && planList.length === 1) ||
            (isREP && !planList.map((a) => a.id).every((ele) => [1, 2, 4, 7].includes(ele))))
        "
      >
        <hr class="upper-line-services" />
        <div class="col-xs-12 text-secondary">
          <div>
            <img src="/static/images/icons/check.svg" class="check-icon-size" alt="check-icon" />
            <span class="pl-10">Purchased Services need to be manually renewed.</span>
          </div>
          <div class="pt-10">
            <img src="/static/images/icons/check.svg" class="check-icon-size" alt="check-icon" />
            <span class="pl-10"
              >Please renew prior to the expiration date to ensure uninterrupted access.</span
            >
          </div>
        </div>
      </div>
      <div v-if="planList && planList.length > 0">
        <div v-for="(service, key) in planList" :key="key">
          <div
            v-if="
              service.id !== 5 &&
              !(service.id == 7 && activeProdClassCount > 0 && service.service_type === 'trial')
            "
            :class="{ 'min-ht-100': service.id === 4 && service.renewed }"
          >
            <hr class="upper-line-services" />
            <div class="row ml-5">
              <div class="col-lg-9 col-md-9 col-sm-9 col-xs-8">
                <img
                  class="check-icon"
                  src="/static/images/icons/circle_check.svg"
                  alt="check-icon"
                />
                <span
                  class="service-name"
                  :class="{ fnt_14: service.id === 13 || service.id === 14 }"
                  >{{ service.name }}</span
                >
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 dollar-year" v-if="!isREP">
                <div
                  class="upgrade-service"
                  v-if="service.id === 1 || service.id === 13 || service.id === 14"
                >
                  <p class="inline-service">${{ service.price }}</p>
                  <span v-if="recordPrice > 0">+ ${{ recordPrice }}</span> per year
                </div>
                <div
                  class="upgrade-service"
                  v-else-if="service.id === 2 && service.service_type === 'premium'"
                >
                  <span>${{ service.price }} per year</span>
                </div>
                <div
                  class="upgrade-service"
                  v-else-if="service.id !== 2"
                  :class="{ 'mb-0': service.id === 15 || service.id === 16 }"
                >
                  <span v-if="service.id === 9 || service.id === 10 || service.id === 12"
                    >${{ service.price }}/use</span
                  >
                  <span v-else>${{ service.price }} per year</span>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 dollar-year" v-if="isREP">
                <div
                  class="upgrade-service"
                  v-if="service.id !== 2"
                  :class="{ 'mb-0': service.id === 15 || service.id === 16 }"
                >
                  <span v-if="service.id === 9 || service.id === 10 || service.id === 12"
                    >${{ service.price }}/use</span
                  >
                  <span v-else-if="service.id === 15 || service.id === 16"
                    >${{ service.price }} per year</span
                  >
                </div>
              </div>
            </div>
            <div class="row" v-if="service.id === 2">
              <div
                class="col-md-offset-1 col-lg-offset-1 col-sm-offset-1 col-lg-11 col-md-11 col-sm-11 col-xs-11"
              >
                <div class="mb-5" v-if="regIntellMarket === 'all'">All markets included</div>
                <template
                  v-if="
                    regIntellMarket === 'multiple' || (isDefaultMarket && regIntellMarket !== 'all')
                  "
                >
                  <div class="mb-5">Selected markets</div>
                  <span
                    class="available-upto"
                    v-for="(country, index) in displayCountries"
                    :key="index"
                    >{{ country }}<span v-if="displayCountries.length > index + 1">, </span></span
                  >
                  <span
                    class="cust-link"
                    v-if="viewMore && countries.length > 5"
                    @click="viewMore = false"
                    >,... View more</span
                  >
                  <span
                    class="cust-link"
                    v-if="!viewMore && countries.length > 5"
                    @click="viewMore = true"
                  >
                    View less</span
                  >
                </template>
              </div>
            </div>
            <!-- <div class="row mb-20" v-if="[15, 16].includes(service.id) && !service.expiry_date">
              <div
                class="col-sm-offset-1 col-lg-11 col-md-11 col-sm-11 col-xs-11 free-service-renews"
              >
                <div class="free-renews">
                  <span>Expires on {{ service.valid_until | dateFormat }} </span>
                </div>
              </div>
            </div> -->
            <div class="row position-relative" :class="{ min_hght_32: service.renewed }">
              <div
                class="col-xs-offset-1 col-xs-8 reg-records"
                v-if="service.id === 1 || service.id === 13 || service.id === 14"
              >
                <div class="registration-records">Registrations Records</div>
                <div class="records-available" v-if="Object.keys(records).length">
                  <span class="available-item">
                    <span
                      v-if="
                        records.total_limit >= records.default_limit &&
                        records.is_active &&
                        todayDate() <= $options.filters.serviceExpDateFormat(records.valid_until) &&
                        todayDate() >= $options.filters.serviceExpDateFormat(records.valid_from)
                      "
                      >{{ records.total_limit - records.current_utilization }} of
                      {{ records.total_limit }}</span
                    >
                    <span v-else
                      >{{ records.default_limit - records.current_utilization }} of
                      {{ records.default_limit }}</span
                    >
                  </span>
                  <span class="available-upto">&nbsp;available</span>
                </div>
                <div
                  class="mb-5 pt-10"
                  v-if="regIntellMarket === 'all' && (service.id === 13 || service.id === 14)"
                >
                  Regulatory Intelligence all markets included
                </div>
                <div class="mb-5 pt-10" v-if="service.id === 14">
                  Regulatory Reports all markets included
                </div>
              </div>
              <div
                class="col-xs-offset-1 col-xs-11 reg-records"
                v-if="service.service_type === 'premium' && (service.id === 9 || service.id === 10)"
              >
                <div class="registration-records">
                  <div>{{ service.name }} usage</div>
                </div>
                <div class="records-available">
                  <span class="available-item">
                    <span v-if="service.id === 9"
                      >{{ rationaleRepUtil.total_limit - rationaleRepUtil.current_utilization }} of
                      {{ rationaleRepUtil.total_limit }}</span
                    >
                    <span v-if="service.id === 10"
                      >{{
                        rationaleRepEmergoUtil.total_limit -
                        rationaleRepEmergoUtil.current_utilization
                      }}
                      of {{ rationaleRepEmergoUtil.total_limit }}</span
                    >
                    <span class="available-upto">&nbsp;available </span>
                  </span>
                </div>
              </div>
              <div class="col-xs-offset-1 col-sm-5 col-xs-11 reg-records" v-if="service.id === 16">
                <div class="registration-records" :class="{ 'mt-20': service.expiry_date }">
                  All Markets Available
                </div>
              </div>
              <div
                class="col-xs-offset-1 col-sm-5 col-xs-11 reg-records"
                v-if="service.id === 15 || service.id === 13"
              >
                <div class="registration-records pt-16">
                  {{ selectedCountryList.length }} Markets added out of 3 available markets
                </div>
                <div class="mt-5">
                  <ul class="regreport-ul">
                    <li>Current Markets: {{ getCountriesList }}</li>
                  </ul>
                </div>
              </div>
              <div
                class="col-sm-6 col-xs-offset-1 col-sm-offset-0 col-xs-11"
                v-if="(service.id === 15 || service.id === 13) && subscribedMarkets.length < 3"
              >
                <p class="select-mrkt renew-service">
                  Select Markets (Up to 3 markets can be selected)
                </p>
                <multiselect
                  :disabled="
                    regReportMarketSelection == 'allMarkets' || selectedCountryList.length > 3
                  "
                  :showLabels="false"
                  :close-on-select="false"
                  class="multiselect-single-dropdown multiselect-multiple wd-80 renew-service"
                  :class="!selectedCountryList.length ? 'un-selected' : ''"
                  placeholder="Select Market(s)"
                  label="country_name"
                  track-by="country_name"
                  :multiple="true"
                  :searchable="true"
                  :clear-on-select="false"
                  :options="unsubscribedMarkets"
                  :value="selectedCountryList"
                  @close="countryListUpdates(service)"
                >
                  <div class="selection-count" slot="selection" slot-scope="{ values, isOpen }">
                    <template v-if="!isOpen">
                      <img
                        src="/static/images/icons/filter.svg"
                        alt="filter-icon"
                        class="image-size"
                      /><span class="selected-count">{{ values.length }} Selected</span>
                    </template>
                    <template v-else-if="isOpen">
                      <img
                        src="/static/images/icons/filter.svg"
                        alt="filter-icon"
                        class="image-size"
                      />
                    </template>
                  </div>
                  <span slot="option" slot-scope="props">
                    <div
                      class="d-flex"
                      @input="updateSelectedCountryList(props.option, 'reg-report')"
                    >
                      <span class="checkbox inline-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            :value="props.option.country_name"
                            :checked="selectedCountryList.includes(props.option)"
                          />
                          <span
                            class="cr"
                            :class="{
                              'disabled-checkbox': selectedCountryList.length == 3
                            }"
                          >
                          </span>
                        </label>
                      </span>
                      <div
                        :class="{
                          'font-bold': selectedCountryList.includes(props.option),
                          'font-wt-400': !selectedCountryList.includes(props.option),
                          'disabled-text': selectedCountryList.length == 3
                        }"
                        @click="updateSelectedCountryList(props.option, 'reg-report')"
                      >
                        {{ props.option.country_name }}
                      </div>
                    </div>
                  </span>
                  <span slot="noResult">No matching data</span>
                </multiselect>
              </div>
              <div
                class="renew-class"
                v-if="service.renewed && !service.renewedBundle"
                :class="{
                  'renew-class-2': service.id === 2 || service.id === 15,
                  'renew-class-3': service.id === 16
                }"
              >
                <img
                  src="static/images/icons/checkbox.svg"
                  class="success_logo card-img-top"
                  alt="checkbox-icon"
                /><br />
                <span class="pt-10"> Renewed </span>
              </div>
            </div>
            <div class="row mr-0" v-if="service.id === 15">
              <div class="col-sm-offset-1 col-sm-11 col-xs-12 pl-0">
                <hr class="upper-line-services" />
              </div>
            </div>
            <div class="row">
              <div class="col-xs-offset-1 col-lg-6 col-md-5 col-sm-5 col-xs-11 free-service-renews">
                <div class="free-renews" v-if="!isREP && service.id != 2">
                  <span class="expiration-title" v-if="service.expiry_date">
                    <img
                      class="traingle-alert"
                      src="/static/images/icons/alert_triangle.svg"
                      alt="alert-icon"
                    />
                    <b>Expires</b> {{ service.expiry_date | dateFormat }}
                  </span>
                  <span v-else>
                    <span v-if="service.id === 3"
                      >Until {{ service.valid_until | dateFormat }}</span
                    >
                    <span
                      v-if="
                        service.id !== 3 &&
                        service.id !== 7 &&
                        (service.service_type === 'trial' || service.service_type === 'trail')
                      "
                      >Trial ends {{ service.valid_until | dateFormat }}</span
                    >
                    <span v-if="service.id !== 3 && service.service_type === 'premium'">
                      Expires on {{ service.valid_until | dateFormat }}
                    </span>
                  </span>
                </div>
                <div class="free-renews" v-if="isREP && [9, 10, 15, 16].includes(service.id)">
                  <span class="expiration-title" v-if="service.expiry_date">
                    <img
                      class="traingle-alert"
                      src="/static/images/icons/alert_triangle.svg"
                      alt="alert-icon"
                    />
                    <b>Expires</b> {{ service.expiry_date | dateFormat }}
                  </span>
                  <span v-else>
                    <span
                      v-if="
                        service.id !== 3 &&
                        (service.service_type === 'trial' || service.service_type === 'trail')
                      "
                      >Trial ends</span
                    >
                    <span v-if="service.service_type === 'premium'"
                      >Expires on {{ service.valid_until | dateFormat }}
                    </span>
                  </span>
                </div>
                <div
                  class="free-renews"
                  v-if="
                    !isREP &&
                    service.id == 2 &&
                    ((countries && countries.length > 1 && isDefaultMarket) ||
                      (countries && countries.length > 0 && !isDefaultMarket) ||
                      allMarketsSelected)
                  "
                >
                  <span class="expiration-title" v-if="service.expiry_date">
                    <img
                      class="traingle-alert"
                      src="/static/images/icons/alert_triangle.svg"
                      alt="alert-icon"
                    />
                    <b>Expires</b> {{ service.expiry_date | dateFormat }}
                  </span>
                  <span v-else>
                    <span v-if="service.service_type === 'premium'"
                      >Expires on {{ service.valid_until | dateFormat }}
                    </span>
                  </span>
                </div>
                <div class="free-renews" v-if="isREP">
                  <span
                    v-if="
                      service.id !== 3 &&
                      service.id !== 15 &&
                      service.id !== 16 &&
                      service.id !== 9 &&
                      service.id !== 10
                    "
                    >Included with your In-country Representation service</span
                  >
                  <span v-if="service.id === 3">
                    <span class="expiration-title" v-if="service.expiry_date">
                      <img
                        class="traingle-alert"
                        src="/static/images/icons/alert_triangle.svg"
                        alt="alert-icon"
                      />
                      <b>Expires</b> {{ service.expiry_date | dateFormat }}
                    </span>
                    <span v-else>Until {{ service.valid_until | dateFormat }} </span>
                  </span>
                </div>
                <div class="free-renews" v-if="service.id === 15">
                  Upgrade to report access to all markets
                </div>
              </div>
              <div class="col-xs-offset-1 col-sm-offset-0 col-lg-5 col-md-6 col-sm-6 col-xs-6">
                <template
                  v-if="
                    service &&
                    service.service_type === 'premium' &&
                    !service.expiry_date &&
                    !service.renewed &&
                    !service.renewedBundle &&
                    service.id === 1
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button
                      class="btn emergo-white-button"
                      data-toggle="modal"
                      data-target="#UpgradeModal"
                      @click="upgradeService(service, 'service')"
                    >
                      Upgrade service
                    </button>
                  </div>
                </template>
                <template
                  v-if="
                    service &&
                    service.service_type === 'premium' &&
                    !service.expiry_date &&
                    !service.renewed &&
                    !service.renewedBundle &&
                    service.id === 13
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button class="btn emergo-white-button" @click="payForService(service)">
                      Upgrade service
                    </button>
                  </div>
                </template>
                <template v-if="service.id === 3 && projectsList.length">
                  <div class="upgrade-service upgrade-service-btn">
                    <button
                      class="btn emergo-white-button"
                      data-toggle="modal"
                      data-target="#SBRenewalPopup"
                      @click="SBRenewalPopup(service)"
                    >
                      Contact Us to Renew
                    </button>
                  </div>
                </template>
                <template
                  v-if="
                    !isREP &&
                    service.expiry_date &&
                    !service.renewed &&
                    !service.renewedBundle &&
                    service.service_type === 'premium' &&
                    (service.id === 1 ||
                      service.id === 2 ||
                      service.id === 4 ||
                      service.id === 6 ||
                      service.id === 7 ||
                      service.id === 13 ||
                      service.id === 14)
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button class="btn emergo-green-button" @click="renewService(service)">
                      Renew service
                    </button>
                  </div>
                </template>
                <template
                  v-if="
                    service.expiry_date &&
                    !service.renewed &&
                    !service.renewedBundle &&
                    service.service_type === 'premium' &&
                    (service.id === 15 || service.id === 16)
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button class="btn emergo-green-button" @click="renewService(service)">
                      Renew service
                    </button>
                  </div>
                </template>
                <template v-if="service && service.id === 2 && service.service_type == 'trial'">
                  <div class="upgrade-service upgrade-service-btn">
                    <button class="btn emergo-white-button" @click="payForService(service)">
                      Purchase service
                    </button>
                  </div>
                </template>
                <template
                  v-if="
                    service &&
                    !service.expiry_date &&
                    !service.renewed &&
                    service.id === 2 &&
                    (isDefaultMarket || (countries && countries.length > 0)) &&
                    !allMarketsSelected
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button class="btn emergo-white-button" @click="payForService(service)">
                      Upgrade service
                    </button>
                  </div>
                </template>
                <template
                  v-if="
                    service &&
                    service.service_type !== 'premium' &&
                    service.id !== 2 &&
                    !service.renewed
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button class="btn emergo-white-button" @click="payForService(service)">
                      Purchase service
                    </button>
                  </div>
                </template>
                <template
                  v-if="
                    service &&
                    service.service_type === 'premium' &&
                    service.id === 15 &&
                    !service.expiry_date &&
                    !service.renewed
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button
                      class="btn emergo-white-button"
                      data-toggle="modal"
                      data-target="#regReportUpgradeModal"
                      @click="upgradeService(service, 'regreportservice')"
                    >
                      Upgrade service
                    </button>
                  </div>
                </template>
                <template
                  v-if="
                    service &&
                    service.service_type === 'premium' &&
                    (service.id === 9 || service.id === 10 || service.id === 12)
                  "
                >
                  <div class="upgrade-service upgrade-service-btn">
                    <button class="btn emergo-white-button" @click="payForService(service)">
                      <span class="purchase-more">Purchase more</span>
                    </button>
                  </div>
                </template>
              </div>
            </div>
            <div class="row" v-if="service.id !== 2">
              <div
                class="col-xs-offset-1 col-lg-8 col-md-8 col-sm-8 free-service-renews col-xs-11"
                v-if="service.id === 3 && projectsList.length"
              >
                <p class="free-renews">
                  View only mode after project completion unless renewed annually
                </p>
                <span class="expiration-title" v-if="getExpiringProjectsCount()">
                  <img
                    class="traingle-alert"
                    src="/static/images/icons/alert_triangle.svg"
                    alt="alert-icon"
                  />
                  <span>Expiring soon {{ getExpiringProjectsCount() }} project(s)</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <template v-if="!isREP && isProductClassificationActive && planList.length === 1">
          <div class="row m-0">
            <hr class="upper-line-services" />
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-25">
              <notification-no-service @closepopup="$emit('closepopup')"></notification-no-service>
            </div>
          </div>
        </template>
      </div>
      <div class="row m-0" v-else>
        <hr class="upper-line-services" />
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-25">
          <notification-no-service @closepopup="$emit('closepopup')"></notification-no-service>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <renew-modal @payForUpgradeService="payForUpgradeService"></renew-modal>
    <upgrade-modal
      :selectedService="selectedService"
      :addonType="addonType"
      @payForUpgradeService="payForUpgradeService"
    ></upgrade-modal>
    <reg-report-upgrade-modal
      :selectedService="selectedService"
      :addonType="addonType"
      @payForUpgradeService="payForUpgradeService"
    ></reg-report-upgrade-modal>
    <confirmation-modal :selectedService="selectedService"></confirmation-modal>
    <sb-contact-renewal-modal
      :selectedService="selectedService"
      :projectsList="projectsList"
    ></sb-contact-renewal-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { cloneDeep, isEqual, sortBy } from 'lodash';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import UpgradeModal from './CommonComponents/UpgradeModal.vue';
import RegReportUpgradeModal from './CommonComponents/RegReportUpgradeModal.vue';
import RenewModal from './CommonComponents/RenewalModal.vue';
import ConfirmationModal from './CommonComponents/ConfirmationModal.vue';
import { getUserData, getProfileData } from '../../apis/profile';
import { getSubscribedPlans, getPlanPrice } from '../../apis/plans';
import { getExpiryServices } from '../../apis/notification';
import { getAddonDetails, getPaymentModeById, getRenewedServices, postPlan } from '../../apis/psm';
import { getTeamMemberRestrictedUsersCount } from '../../apis/team';
import {
  getAllRegIntelCountries,
  isDefaultAvailable,
  isAllCountriesSelected,
  getAvailableRegIntelCountries
} from '../../apis/regulatoryIntelligence';
import NotificationNoService from './NotificationNoService.vue';
import SbContactRenewalModal from './SbContactRenewalModal.vue';
import { getSBExpiringProjects } from '../../apis/submissionBuilder';
import { getRegReportMarket } from '../../apis/marketPlace';
import { getActiveProdClassCount } from '../../apis/prodClassification';

export default {
  components: {
    Loader,
    UpgradeModal,
    ConfirmationModal,
    NotificationNoService,
    RenewModal,
    SbContactRenewalModal,
    RegReportUpgradeModal
  },
  props: ['roleId'],
  data() {
    return {
      activeProdClassCount: 0,
      regIntellMarket: '',
      isDefaultMarket: false,
      allMarketsSelected: false,
      countries: [],
      viewMore: true,
      loaderStatus: false,
      services: [],
      planList: [],
      teamMember: {},
      records: {},
      storage: {},
      addonType: '',
      isREP: false,
      selectedService: {},
      recordPrice: 0,
      teamPrice: 0,
      teamLimit: 0,
      prodClassUtil: {},
      regPathwayUtil: {},
      rationaleRepUtil: {},
      rationaleRepEmergoUtil: {},
      expiryServicesList: [],
      expiryAddOnList: [],
      renewedServicesList: [],
      renewedAddonList: [],
      regIntelPrice: 0,
      restrictedUsersCount: 0,
      accountId: null,
      projectsList: [],
      countryList: [],
      regReportMarketSelection: '',
      selectedCountryList: [],
      subscribedMarkets: [],
      unsubscribedMarkets: [],
      payment_option: 4
    };
  },
  computed: {
    isProductClassificationActive() {
      const service = this.planList.find((plan) => plan.id === 7 && plan.service_type === 'trial');
      return !!(this.activeProdClassCount && service);
    },
    getCountriesList() {
      if (this.selectedCountryList) {
        if (this.selectedCountryList.length === 1) {
          return this.selectedCountryList.map((e) => e.country_name).join('');
        }
        if (this.selectedCountryList.length > 1) {
          return `${this.selectedCountryList
            .slice(0, this.selectedCountryList.length - 1)
            .map((e) => e.country_name)
            .join(', ')} and ${
            this.selectedCountryList[this.selectedCountryList.length - 1].country_name
          }`;
        }
      }
      return '-';
    },
    displayCountries() {
      if (this.viewMore && this.countries.length > 5) {
        return this.countries.slice(0, 5);
      }
      return this.countries;
    },
    displayRenewAll() {
      if (this.planList.length) {
        const displayLength = this.planList.filter((service) => {
          const response = this.expiryServicesList.find((o) => o.name === service.name);
          const res2 = this.renewedServicesList.find(
            (o) =>
              o === service.id ||
              o === 13 ||
              o === 14 ||
              (service.id === 15 && o === 16) ||
              (service.id === 16 && o === 15)
          );
          const res = this.renewedServicesList.find(
            (o) => o === 1 || o === 2 || o === 4 || o === 7 || o === 15 || o === 16
          );
          if ((service.id === 13 || service.id === 14) && res) {
            service.renewedBundle = true;
          }
          return (
            response &&
            response.expiry_date &&
            !res2 &&
            !res &&
            service.service_type === 'premium' &&
            !service.renewed &&
            !service.renewedBundle
          );
        }).length;
        return displayLength > 1;
      }
      return false;
    }
  },
  methods: {
    todayDate() {
      return moment().utc().format('YYYY-MM-DD');
    },
    goToMarketPlace() {
      this.$emit('closepopup', 'closeBasePopup');
      this.$router.push('/layout/market-place');
    },
    async getAddedServiceDetails() {
      this.loaderStatus = true;
      this.services = await getSubscribedPlans(this.accountId);
      await this.isDefaultAvailable();
      await this.getActivePlansList();
      await this.getAddonDetails();
      this.allCountryList = await getAllRegIntelCountries();
      await this.isAllCountriesSelected();
      if (this.services.findIndex((e) => e.id === 15 || e.id === 16 || e.id === 13) > -1)
        await this.getCountries();
      this.loaderStatus = false;
    },
    async getActivePlansList() {
      this.planList = this.services.filter((s) => s.id !== 8);
      this.planList.forEach(async (plan, i) => {
        if (plan.id === 3) {
          this.planList[i].price = await getPlanPrice(plan.id, this.accountId);
        }
      });
      const expiryServices = await getExpiryServices(this.accountId);
      if (expiryServices.data.add_on && expiryServices.data.add_on.length > 0) {
        this.expiryAddOnList = expiryServices.data.add_on;
      }
      if (expiryServices.data.plan) {
        this.expiryServicesList = expiryServices.data.plan;
        this.planList.forEach((service, index) => {
          const response = this.expiryServicesList.find((o) => o.name === service.name);
          if (response) {
            if ((service.id === 1 || service.id === 13 || service.id === 14) && this.isREP) {
              return;
            }
            this.planList[index].expiry_date = response.expiry_date;
          }
        });
      }
      const renewedServices = await getRenewedServices(this.accountId);
      if (renewedServices.data.add_on && renewedServices.data.add_on.length > 0) {
        this.renewedAddonList = renewedServices.data.add_on;
      }
      if (this.isDefaultMarket) {
        if (
          !this.planList.find(
            (plan) => plan.id === 2 || plan.id === 6 || plan.id === 13 || plan.id === 14
          )
        ) {
          this.planList.push({
            id: 2,
            name: 'Regulatory Intelligence'
          });
        }
      }
      if (renewedServices.data.plan) {
        this.renewedServicesList = renewedServices.data.plan;
        this.planList.forEach((service, index) => {
          const response = this.renewedServicesList.find(
            (o) =>
              o === service.id ||
              o === 13 ||
              o === 14 ||
              (service.id === 15 && o === 16) ||
              (service.id === 16 && o === 15)
          );
          if (
            response &&
            (this.planList[index].id === 1 ||
              this.planList[index].id === 2 ||
              this.planList[index].id === 4 ||
              this.planList[index].id === 7 ||
              this.planList[index].id === 13 ||
              this.planList[index].id === 14 ||
              this.planList[index].id === 15 ||
              this.planList[index].id === 16)
          ) {
            if (
              this.planList[this.planList.findIndex((p) => p.id === 15)] &&
              this.renewedServicesList.includes(16)
            ) {
              this.planList[this.planList.findIndex((p) => p.id === 15)].renewed = true;
            } else if (
              this.planList[this.planList.findIndex((p) => p.id === 16)] &&
              this.renewedServicesList.includes(15)
            ) {
              this.planList[this.planList.findIndex((p) => p.id === 16)].renewed = true;
            }
            this.planList[index].renewed = true;
          }
          const res = this.renewedServicesList.find(
            (o) => o === 1 || o === 2 || o === 4 || o === 7 || o === 15 || o === 16
          );
          if ((this.planList[index].id === 13 || this.planList[index].id === 14) && res) {
            this.planList[index].renewedBundle = true;
          }
        });
      }
    },
    async getAddonDetails() {
      this.addonDetails = await getAddonDetails(this.accountId);
      const index = this.addonDetails.findIndex((addon) => addon.units === 'RECORDS');
      if (index >= 0) {
        this.records = this.addonDetails[index];
        const totalLimit = this.records.total_limit;
        if (totalLimit <= 250) {
          this.recordPrice = 0;
        } else if (totalLimit > 250 && totalLimit <= 1000) {
          this.recordPrice = 200;
        } else if (totalLimit > 1000 && totalLimit <= 2000) {
          this.recordPrice = 300;
        } else if (totalLimit > 2000 && totalLimit <= 3000) {
          this.recordPrice = 400;
        } else if (totalLimit > 3000 && totalLimit <= 4000) {
          this.recordPrice = 500;
        } else if (totalLimit > 4000 && totalLimit <= 5000) {
          this.recordPrice = 600;
        }
      }
      const storageIndex = this.addonDetails.findIndex((addon) => addon.units === 'STORAGE');
      if (index >= 0) {
        this.storage = this.addonDetails[storageIndex];
      }
      const teamIndex = this.addonDetails.findIndex((addon) => addon.units === 'USERS');
      if (teamIndex >= 0) {
        this.teamMember = this.addonDetails[teamIndex];
        const response = this.expiryAddOnList.find((o) => o.name === 'Team members');
        if (response) {
          this.teamMember.expiry_date = response.expiry_date;
        }
        const res = this.renewedAddonList.find((o) => o === 1);
        if (res) {
          this.teamMember.renewed = true;
        }
        // if ((this.teamMember.total_limit > this.teamMember.default_limit) && this.teamMember.is_active && this.todayDate() < this.teamMember.valid_until && this.todayDate() >= this.teamMember.valid_from) {
        if (this.isREP) {
          this.teamLimit = this.teamMember.total_limit - 1;
        } else {
          this.teamLimit = this.teamMember.total_limit;
        }
        // } else {
        //   this.teamLimit = this.teamMember.default_limit;
        // }
        if (this.teamLimit <= 5) {
          this.teamPrice = 0;
        } else {
          this.teamPrice = (this.teamLimit - 5) * 100;
        }
      }
      this.prodClassUtil =
        this.addonDetails[this.addonDetails.findIndex((addon) => addon.id === 5)];
      this.regPathwayUtil =
        this.addonDetails[this.addonDetails.findIndex((addon) => addon.id === 9)];
      this.rationaleRepUtil =
        this.addonDetails[this.addonDetails.findIndex((addon) => addon.id === 6)];
      this.rationaleRepEmergoUtil =
        this.addonDetails[this.addonDetails.findIndex((addon) => addon.id === 7)];
      this.restrictedUsersCount = await getTeamMemberRestrictedUsersCount(this.accountId);
    },
    async isDefaultAvailable() {
      this.isDefaultMarket = await isDefaultAvailable(this.accountId);
    },
    regIntelvalidUntil() {
      const index = this.addonDetails.findIndex((addon) => addon.units === 'COUNTRIES');
      if (index >= 0) {
        return moment.utc(this.addonDetails[index].valid_until).format('YYYY-MM-DD HH:mm:ss');
      }
      return null;
    },
    renewDate() {
      return moment.utc('12/31/2021').format('YYYY-MM-DD HH:mm:ss');
    },
    async isAllCountriesSelected() {
      this.allMarketsSelected = await isAllCountriesSelected(11, this.accountId);
      if (this.allMarketsSelected) {
        this.regIntellMarket = 'all';
        this.regIntelPrice = 499;
      } else {
        this.regIntellMarket = 'multiple';
        const selectedIds = await getAvailableRegIntelCountries(this.accountId);
        const newList = [];
        let countryData = '';
        selectedIds.forEach((c) => {
          countryData = this.allCountryList.find((each) => each.country_id === c);
          if (countryData) {
            newList.push(countryData);
          }
        });
        this.countries = newList.map((a) => a.country_name);
        if (this.isDefaultMarket) {
          this.regIntelPrice = (this.countries.length - 1) * 99;
        } else {
          this.regIntelPrice = this.countries.length * 99;
        }
      }
    },
    upgradeService(service, type) {
      this.selectedService = service;
      this.addonType = type;
    },
    SBRenewalPopup(service) {
      this.selectedService = service;
    },
    async payForService(service) {
      this.$emit('closepopup', 'closeBasePopup');
      const profileData = localStorage.getItem('profileData')
        ? JSON.parse(localStorage.getItem('profileData'))
        : await getProfileData();
      const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData'))
        : await getUserData();
      if (userData.id === profileData.id) {
        if (service.id === 15 || service.id === 16) {
          this.$router.push('/layout/market-place/add-service/7');
        } else if (service.id === 13) {
          this.$router.push('/layout/market-place/add-service/10');
        } else if (service.id === 7) {
          this.$router.push('/layout/market-place/add-service/6');
        } else if (service.id === 9 || service.id === 10) {
          const params = {
            serviceId: 6,
            serviceIdsToDisplay: [9, 10],
            defaultSelectedService: service.id
          };
          this.$router.push({ name: 'addService', params });
        } else if (service.id === 12) {
          const params = {
            serviceId: 6,
            serviceIdsToDisplay: [12],
            defaultSelectedService: 12
          };
          this.$router.push({ name: 'addService', params });
        } else {
          this.$router.push(`/layout/market-place/add-service/${service.id}`);
        }
      } else {
        this.$router.push('/layout/dashboard');
      }
    },
    async renewService(service) {
      this.$emit('closepopup', 'closeBasePopup');
      const profileData = localStorage.getItem('profileData')
        ? JSON.parse(localStorage.getItem('profileData'))
        : await getProfileData();
      const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData'))
        : await getUserData();
      if (userData.id === profileData.id) {
        if (service.id !== 6) {
          if (this.$route.path === '/layout/market-place/renew-service')
            EventBus.$emit('renewServiceIds', [service.id]);
          else
            this.$router.push({
              name: 'renewService',
              params: { serviceIds: [service.id] }
            });
        } else if (service.id === 6) {
          if (this.$route.path === '/layout/market-place/renew-service')
            EventBus.$emit('renewServiceIds', [13]);
          else
            this.$router.push({
              name: 'renewService',
              params: { serviceIds: [13] }
            });
        }
      } else {
        this.$router.push('/layout/dashboard');
      }
    },
    async payForUpgradeService(service, selection = {}, isRenewal = false) {
      this.$emit('closepopup', 'closeBasePopup');
      const profileData = localStorage.getItem('profileData')
        ? JSON.parse(localStorage.getItem('profileData'))
        : await getProfileData();
      const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData'))
        : await getUserData();
      if (userData.id === profileData.id) {
        const { id, is_account: isAccount, units } = service;
        const isUpgradeAccount = id === 1 && isAccount && units === 'USERS';
        if (isUpgradeAccount) this.handleTeamMemberUpdate(service, selection, isRenewal);
        else if (service.id === 1 || service.id === 15)
          this.handleServiceUpdate(service, selection);
        else this.$router.push('/layout/dashboard');
      }
    },
    handleTeamMemberUpdate(service, selection, isRenewal) {
      service.isRenewal = isRenewal;
      const teamMemberData = {
        selection,
        service
      };
      sessionStorage.removeItem('upgradeServices');
      if (this.$route.path === '/layout/market-place/upgrade-service') {
        teamMemberData.isTeamMember = true;
        EventBus.$emit('upgradeService', teamMemberData);
      } else {
        this.$router.push({
          name: 'UpgradeService',
          params: {
            upgradeTeamMember: teamMemberData
          }
        });
      }
    },
    handleServiceUpdate(service, selection) {
      const obj = {
        serviceId: service.id === 15 ? 16 : service.id,
        currentServiceId: service.id,
        selection
      };
      sessionStorage.removeItem('upgradeTeamMember');
      if (this.$route.path === '/layout/market-place/upgrade-service') {
        EventBus.$emit('upgradeService', obj);
      } else this.$router.push({ name: 'UpgradeService', params: { upgradeService: obj } });
    },
    renewExpiringServices() {
      const serviceIds = this.planList
        .filter(
          (service) =>
            service.service_type === 'premium' &&
            service.expiry_date &&
            (service.id === 1 ||
              service.id === 2 ||
              service.id === 4 ||
              service.id === 7 ||
              service.id === 13 ||
              service.id === 14 ||
              service.id === 15 ||
              service.id === 16)
        )
        .map((each) => each.id);
      this.$emit('closepopup', 'closeBasePopup');
      if (this.$route.path === '/layout/market-place/renew-service')
        EventBus.$emit('renewServiceIds', serviceIds);
      else this.$router.push({ name: 'renewService', params: { serviceIds } });
    },
    async getSBExpiringProjects() {
      this.loaderStatus = true;
      this.projectsList = await getSBExpiringProjects(this.accountId);
      this.projectsList = [{
        id: 1,
        name: 'sasddsa',
        expiresAt: moment()
      },{
        id: 2,
        name: 'sasddsa',
        expiresAt: moment()
      },{
        id: 3,
        name: 'sasddsa',
        expiresAt: moment()
      }]
      this.loaderStatus = false;
    },
    getExpiringProjectsCount() {
      return this.projectsList.filter((p) => moment(p.expiresAt).isSameOrAfter(moment(), 'day'))
        .length;
    },
    async countryListUpdates(service) {
      if (!isEqual(sortBy(this.selectedCountryList), sortBy(this.subscribedMarkets))) {
        this.loaderStatus = true;
        const formData = {
          add_on: [
            {
              account: false,
              active: true,
              id: 13,
              price: service.price,
              valid_from: moment(service.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
              valid_until: moment(service.valid_until).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
              volume: this.selectedCountryList.length,
              regulatory_reports: {
                all: false,
                country_id: this.selectedCountryList.map((e) => e.country_id)
              }
            }
          ],
          account_id: JSON.parse(localStorage.getItem('userData')).account_id,
          active: true,
          operation: 13,
          payment_mode: 4,
          plan_id: service.id,
          plan_price: service.price,
          service_type: 'premium',
          total_amount: service.price,
          valid_from: moment(service.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          valid_until: moment(service.valid_until).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        };
        const resp = await postPlan(formData);
        this.loaderStatus = false;
        if (resp.message === 'success' && resp.status_code === 200) {
          this.$notify({
            clear: true,
            group: 'custom-notification'
          });
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Regulatory Reports: Markets updated successfully',
            group: 'custom-notification'
          });
          this.getCountries();
        } else {
          this.$notify({
            clear: true,
            group: 'custom-notification'
          });
          this.$notify({
            type: 'error',
            title: 'Error',
            text: resp.message,
            group: 'custom-notification'
          });
        }
      }
    },
    updateSelectedCountryList(option, serviceType) {
      if (this.selectedCountryList.findIndex((c) => c.country_id === option.country_id) === -1) {
        this.selectedCountryList.push(option);
        if (this.selectedCountryList.length > 3 && serviceType === 'reg-report') {
          this.selectedCountryList.push(option);
          this.$nextTick(() => {
            this.selectedCountryList.splice(3, this.selectedCountryList.length);
          });
        }
      } else {
        this.selectedCountryList = this.selectedCountryList.filter(
          (item) => item.country_id !== option.country_id
        );
      }
    },
    async getCountries() {
      this.selectedCountryList = [];
      const markets = await getRegReportMarket(localStorage.getItem('accountId'));
      this.unsubscribedMarkets = markets.unsubscribed_markets;
      markets.subscribed_markets.filter((e) =>
        this.selectedCountryList.push(
          markets.all_markets.find((a) => a.country_id === e.country_id)
        )
      );
      this.subscribedMarkets = cloneDeep(this.selectedCountryList);
    }
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    serviceExpDateFormat(date) {
      return moment.utc(date).format('YYYY-MM-DD');
    }
  },
  async mounted() {
    this.isREP =
      JSON.parse(localStorage.getItem('userData')).account_type_id === 2 ||
      JSON.parse(localStorage.getItem('userData')).account_type_id === 4;
    this.accountId = JSON.parse(localStorage.getItem('userData')).account_id
      ? JSON.parse(localStorage.getItem('userData')).account_id
      : await getUserData();
    this.activeProdClassCount = await getActiveProdClassCount(
      JSON.parse(localStorage.getItem('userData')).account_id
    );
    await this.getAddedServiceDetails();
    await this.getSBExpiringProjects();
    this.loaderStatus = true;
    this.payment_option = await getPaymentModeById(this.accountId);
    this.loaderStatus = false;
  }
};
</script>

<style lang="scss" scoped>
$light-grey: #f2f2f2;
$blue-color: #00518a;

.select-mrkt {
  font-family: 'Roboto';
  font-style: normal;
  @include fontItems($font-14, 16px, $font-weight-400);
  color: $dark-black-alpha;
}

.pt-16 {
  padding-top: 16px;
}
.wd-80 {
  width: 310px;
}
.add_icon_img {
  padding-bottom: 3px;
}
.fnt_14 {
  font-size: $font-14;
}
.check-icon-size {
  width: 16px;
  height: 16px;
  margin-top: -4px;
}
.text-secondary {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  padding-top: 6px;
  padding-bottom: 18px;
}
.alert-image {
  background-image: url(/static/images/icons/alert_triangle.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 50px;
  height: 57px;
  position: relative;
  background-size: 40px;
  .tooltiptext {
    visibility: hidden;
    width: 351px;
    background-color: $light-grey;
    color: $dark-black-alpha;
    text-align: center;
    border-radius: $radius10;
    padding: 16px;
    position: absolute;
    z-index: 1;
    top: 3.8em;
    left: -1em;
    margin-left: -60%;
    opacity: 0;
    transition: opacity 1s;
    box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.5);
    font-size: $font-18;
    line-height: 21px;
    font-weight: $font-weight-400;
    text-align: left;
    word-break: break-word;
    &::after {
      display: unset;
      position: absolute;
      pointer-events: none;
      content: '';
      transform: rotate(45deg);
      width: 1em;
      height: 1em;
      background: $light-grey;
      z-index: -10;
      top: -0.4em;
      left: 3.4em;
      box-shadow: none;
      margin: auto;
    }
  }
  &:hover {
    .tooltiptext {
      visibility: visible;
      opacity: 1;
    }
  }
}
.position-relative {
  position: relative;
}
.min_hght_32 {
  min-height: 32px;
}
.min-ht-100 {
  min-height: 100px;
}
.renew-class {
  color: $blue-color;
  position: absolute;
  right: 45px;
  top: -4px;
  text-align: center;
}
.renew-class-2 {
  top: -35px;
}
.renew-class-3 {
  top: 12px;
}
.top_28 {
  top: 28px;
}
.display-flex {
  display: -webkit-box;
  align-items: center;
}
.font-16 {
  font-size: $font-16;
}
.cust-link {
  margin-top: 5px;
  color: $messenger-blue;
  font-size: $font-14;
  cursor: pointer;
}
.market_place_img {
  width: 18%;
  margin-top: 7%;
}
.ml-5 {
  margin-left: 5px;
}
.main-add-services {
  top: 54px;
  right: 47px;
  position: absolute;
}
img {
  &.success_logo {
    &.card-img-top {
      width: 30px;
      height: 30px;
      background-color: $blue-color;
      border-radius: 50%;
      padding: 6px;
    }
  }
}
.upgrade-service,
.renew-service {
  text-align: end;
  margin-right: 32px;
}
.upgrade-service {
  margin-bottom: 20px;
  margin-top: 6px;
  &.mb-0 {
    margin-bottom: 0;
  }
}
.dollar-year {
  text-align: end;
  font-size: $font-16;
  line-height: 19px;
  color: $dark-black-alpha;
}
.box-wrapper {
  overflow-y: auto;
  max-height: calc(84vh - 100px);
  overflow-x: hidden;
  padding-bottom: 100px;
  hr {
    &.upper-line {
      margin: 7px 32px 9px 0px;
    }
    &.upper-line-records {
      margin: 9px 32px 13px 53px;
    }
  }
}
ul {
  &.regulatory-intelligence {
    list-style: none;
    padding-left: 0px;
  }
}
.team-member-reg,
.registration-records {
  font-weight: $font-weight-bold;
  font-size: $font-16;
  line-height: 19px;
  color: $dark-black-alpha;
  padding-bottom: 4px;
}
.registration-records {
  padding-bottom: 9px;
}
.regreport-ul {
  font-family: 'Roboto';
  font-style: normal;
  @include fontItems($font-16, 21px, $font-weight-400);
  padding-left: 20px;
  color: $dark-black-alpha;
}
span {
  &.available-item {
    font-weight: $font-weight-medium;
    font-size: $font-20;
    line-height: 28px;
    color: $dark-black-alpha;
  }
  &.total-record {
    font-size: $font-18;
    line-height: 21px;
    color: $dark-black-alpha;
  }
}
.reg-tracker-service {
  font-size: $font-20;
  text-align: center;
  color: $black;
  padding-top: 10px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  text-align: center;
  color: $dark-black-alpha;
  .reg-tracker-para {
    padding-bottom: 5px;
  }
}
.acct-service {
  @include fontItems($font-18, 21px, $font-weight-small);
  color: $dark-black-alpha;
  padding-left: 10px;
}
.team-members {
  padding-left: 40px;
}
.available-upto {
  font-size: $font-14;
  line-height: 16px;
  color: $dark-black-alpha;
}
.check-icon {
  padding-right: 12px;
}
.free-renews {
  padding-top: 9px;
  color: $dark-black-alpha;
  font-size: $font-16;
  line-height: 19px;
}
.country_list {
  color: $dark-black-alpha;
  font-size: $font-16;
}
.upper-line-services {
  margin: 12px 32px 12px 0px;
}
.reg-records,
.free-service-renews {
  padding-left: 25px;
}
.modal-header {
  .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    @include fontItems($font-32, 17px, $font-weight-small);
    color: $deep-gray;
    width: 17px;
    border-radius: $radius20;
    outline: none;
  }
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
  }
  &.scnd-cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding-bottom: 0px;
  }
  &.upgradeModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
  }
}
.modal-footer {
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding-bottom: 32px;
  }
}
.submit-btn {
  background: $primary;
  border: 1px solid $primary;
  box-sizing: border-box;
  border-radius: $radius20;
  color: $light-grey;
  font-size: $font-16;
  line-height: 19px;
  text-align: center;
  padding: 7px 41px 11px;
}
.upgrade-service a,
.cancel-services a {
  cursor: pointer;
}
.modal-content {
  &.first-modal-content {
    border-radius: 12px;
  }
}
.cancel-service-para {
  font-size: $font-18;
  text-align: center;
  color: $black;
  padding-top: 10px;
}
.reg-intelligence-para {
  font-size: $font-24;
  line-height: 28px;
  text-align: center;
  color: $primary;
  padding-top: 10px;
}
.modal-body-para {
  padding: 5px 55px;
  @include fontItems($font-16, 19px, $font-weight-medium);
  text-align: center;
  color: $deep-gray;
}
.current-service {
  background: $primary;
  border: 1px solid $primary;
  box-sizing: border-box;
  border-radius: $radius20;
  color: $light-grey;
  @include fontItems($font-18, 21px, $font-weight-medium);
  text-align: center;
  padding: 8px 38px;
}
.please-cancel {
  background: $white;
  border: 1px solid $primary;
  box-sizing: border-box;
  border-radius: $radius20;
  color: $primary;
  @include fontItems($font-18, 21px, $font-weight-medium);
  text-align: center;
  padding: 8px 60px;
}
.modal-title {
  &.service-modal-title {
    text-align: center;
  }
}
.cancel-successful {
  padding-top: 16px;
  @include fontItems($font-28, 33px, $font-weight-medium);
  color: $light-green;
}
.process-cancel {
  @include fontItems($font-18, 21px, $font-weight-medium);
  color: $deep-gray;
  padding-top: 16px;
}
.scnd-modal-service {
  font-size: $font-24;
  line-height: 28px;
  text-align: center;
  color: #133d5f;
}
.process-hr-line {
  margin-bottom: 0px;
}
.scnd-service-para {
  padding: 6px 121px;
  font-size: $font-16;
  line-height: 19px;
  text-align: center;
  color: $dark-black-alpha;
}
.textarea-field {
  text-align: center;
  textarea {
    background: $deep-white;
    border: 0.5px solid $deep-gray;
    box-sizing: border-box;
    border-radius: 7px;
  }
}
div#cancelModal {
  background-color: rgba(0, 0, 0, 0.5);
}
div#scnd-cancelModal {
  background-color: rgba(0, 0, 0, 0.9);
}
div#upgradeModal {
  background-color: rgba(0, 0, 0, 0.5);
}
div#ConfirmationModal {
  background-color: rgba(0, 0, 0, 0.6);
}
.upgrade-service-para {
  font-size: $font-24;
  line-height: 28px;
  text-align: center;
  color: $primary;
  padding-top: 10px;
}
.reg-tracker-para {
  font-size: $font-18;
  text-align: center;
  color: $black;
  padding-top: 10px;
}
p {
  &.inline-service {
    display: inline;
  }
}
.traingle-alert {
  margin-right: 10px;
  width: 20px;
  vertical-align: bottom;
}
.expiration-title {
  color: $deep-thick-danger;
  vertical-align: bottom;
}
::v-deep .multiselect-single-dropdown.multiselect-multiple {
  & .multiselect__tags {
    display: flex !important;
  }
  & .image-size {
    margin-left: 4px;
  }
}
@media only screen and (max-width: 767px) {
  .renew-class {
    right: 15px;
  }
  .free-renews {
    padding-bottom: 15px;
  }
  .ml-5 {
    margin-left: -15px;
  }
  .main-add-services {
    right: 15px;
  }
  .upgrade-service-btn {
    text-align: start;
  }
  .upgrade-service,
  .renew-service,
  .upper-line-services {
    margin-right: 0px;
  }
  ul {
    &.regulatory-intelligence {
      padding-left: 0px;
    }
  }
  .acct-service {
    padding-top: 8px;
  }
  .box-wrapper {
    hr {
      &.upper-line {
        margin-right: 0px;
        margin-top: 10px;
      }
    }
    .reg-tracker {
      margin-left: 0px;
    }
  }
  .dollar-year {
    text-align: center;
  }
}
@media (min-width: 767px) and (max-width: 1024px) {
  .box-wrapper {
    max-height: 46vh;
  }
}
@media screen and (width: 768px) {
  .box-wrapper {
    max-height: 52vh;
  }
}
@media (min-width: 1422px) and (max-width: 1599px) {
  .free-service-renews {
    padding-left: 15px;
  }
  .reg-records {
    padding-left: 15px;
  }
}
@media only screen and (min-width: 1600px) {
  .free-service-renews {
    padding-left: 4px;
  }
  .reg-records {
    padding-left: 4px;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .box-wrapper {
    max-height: 60vh;
    padding-bottom: 11px;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .box-wrapper {
    max-height: 55vh;
    padding-bottom: 11px;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .box-wrapper {
    max-height: 60vh;
    padding-bottom: 11px;
  }
}
</style>
